import React, { useMemo } from 'react';
import { getPhaseStationIndex, WORKSHOP_OPERATOR_ROLE_LABELS } from '../../lib/workshopOperatorView';

const PRIORITY_LABELS = {
  urgent: { label: 'Urgent', className: 'bg-destructive/15 text-destructive ring-destructive/30' },
  high: { label: 'Priorité haute', className: 'bg-amber-500/15 text-amber-800 dark:text-amber-200 ring-amber-500/30' },
};

export default function WorkshopLotHeader({
  batch,
  caseData,
  productionPhases = [],
  displayPhase,
  userRole,
}) {
  const { index, total } = useMemo(
    () => getPhaseStationIndex(productionPhases, displayPhase),
    [productionPhases, displayPhase]
  );

  const priority = batch?.priority || caseData?.priority;
  const priorityBadge = PRIORITY_LABELS[priority];

  const postLabel = WORKSHOP_OPERATOR_ROLE_LABELS[userRole] ?? null;
  const caseNumber = caseData?.caseNumber;
  const deadline = batch?.deadline || caseData?.deadline;

  return (
    <div className="rounded-xl border border-border bg-card px-4 py-3 space-y-2 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-base font-bold text-foreground truncate">
            {batch?.patientName || 'Patient'}
            <span className="text-muted-foreground font-normal"> · </span>
            {batch?.batchNumber || 'Lot'}
          </p>
          {displayPhase ? (
            <p className="text-sm text-primary font-semibold mt-0.5 truncate">
              {total > 0 ? `Phase ${index}/${total} · ` : ''}
              {displayPhase.name}
            </p>
          ) : null}
        </div>
        {priorityBadge ? (
          <span
            className={`shrink-0 text-[10px] font-bold uppercase px-2 py-1 rounded-full ring-1 ${priorityBadge.className}`}
          >
            {priorityBadge.label}
          </span>
        ) : null}
      </div>

      <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-muted-foreground">
        {caseNumber ? <span>Cas {caseNumber}</span> : null}
        {deadline ? (
          <span>Échéance {new Date(deadline).toLocaleDateString('fr-FR')}</span>
        ) : null}
        {postLabel ? <span className="font-medium text-foreground">{postLabel}</span> : null}
      </div>
    </div>
  );
}
